(function () {
  'use strict';

  /**
   *
   */
  angular
    .module('crewCreditHoursReport')
    .service('crewCreditHoursReportService', crewCreditHoursReportService);

  function crewCreditHoursReportService(RemoteService, MessageService, EventManagerService,ManageCrewFactory) {
    var self = this;

    self.searchCrewTypes = function (successFn, errorFn) {
      RemoteService.getCrewTypeList().then(
        function (response) {
          successFn(response.crewTypeListDTOs);
        },
        function (error) {
          errorFn(error.msg[0]);
        }
      );
    };

    self.searchCrewNamesByCrewType = function(data,successFn, errorFn){
      var userNamesRequest = {crewType : data.crewTypeCode};
      RemoteService.loadCrewList(userNamesRequest).then(
        function (response) {
          var formatedList = ManageCrewFactory.formatCrewSearchResponse(response.crewList);
          successFn(formatedList);
        },
        function (error) {
          errorFn(error.msg[0]);
        }
      );
    }

  }
})();

